<template>
  <div class="pwdLogin">
    <a-form :form="loginForm" @submit="handleLogin">
      <a-form-item>
        <a-input placeholder="请输入手机号码" :maxLength="20" v-decorator="[
          'telphone',
          {
            rules: [
              { required: true, message: '请输入手机号码' },
            ],
            validateTrigger: 'none'
          }
        ]" />
      </a-form-item>
      <a-form-item>
        <a-input :type="pwdHidden ? 'password' : ''" placeholder="请输入密码" :maxLength="18" v-decorator="['pass', { rules: [{ required: true, message: '请输入密码' }], validateTrigger: 'none' }]" />
        <SvgIcon style="width: 16px; height: 16px;" class="iconStyle" :iconClass="pwdHidden ? 'hidePwd' : 'showPwd'" @click.stop="pwdHidden = !pwdHidden" />
      </a-form-item>
      <form-footer></form-footer>
      <a-form-item>
        <a-button style="width: 370px;background: #4B7DFD;
  border-radius: 6px;" size="large" type="primary" html-type="submit" :loading="loading">登录</a-button>
      </a-form-item>
    </a-form>
    <div v-show="pwdLoginModal" class="login-toast-modal">{{ errorMsg }}</div>
  </div>
</template>
<script>
import formFooter from './FormFooter.vue'
import SvgIcon from '@/components/SvgIcon'

// import md5 from 'md5'
// import { login } from '@/api/login'
export default {
  name: 'PasswordLogin',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loginForm: this.$form.createForm(this, { name: 'loginForm' }),
      checked: false,
      pwdHidden: true,
      pwdLoginModal: false,
      errorMsg: '',
      timer: null,
    }
  },
  components: {
    formFooter,
    SvgIcon
  },
  created() {
    document.addEventListener('click', (e) => {
      if (e.target.className !== 'login-toast-modal' && this.pwdLoginModal) {
        this.closeLoginModal()
      }
    })
  },
  methods: {
    setModal(status, msg) {
      if (!status) {
        this.closeLoginModal()
      } else {
        this.timer = setInterval(() => {
          this.closeLoginModal()
        }, 1000)
        this.pwdLoginModal = true
        this.errorMsg = msg
      }
    },
    handleLogin(e) {
      e.preventDefault()
      const rules = [
        { field: 'telphone', required: true, message: '请输入手机号码' },
        { field: 'pass', required: true, message: '请输入密码' },
      ]
      try {
        rules.forEach(v => {
          const fieldValue = this.loginForm.getFieldValue(v.field) || ''
          if (v.required) {
            if (fieldValue.trim().length === 0) {
              throw new Error(v.message)
            }
          } else if (v.pattern) {
            if (!v.pattern.test(fieldValue)) {
              throw new Error(v.message)
            }
          }
        })
      } catch (error) {
        this.setModal(true, error.message)
        return
      }
      const { telphone, pass } = this.loginForm.getFieldsValue(['telphone', 'pass'])
      this.$emit('login', {
        username: telphone,
        password: pass,
        grant_type: 'stu_password'
      })
      // this.loginForm.validateFields((error, values) => {
      //   console.log(error, values, '4567890')
      //   if (error) return
      //   const { telphone, pass } = values
      //   // this.$emit('login', {
      //   //   telphone,
      //   //   pass: md5(pass + process.env.VUE_APP_SALT)
      //   // })
      //   this.$emit('login', {
      //     username: telphone,
      //     password: pass,
      //     grant_type: 'stu_password'
      //   })
      // })
    },
    // 关闭局部登录模块局部弹窗
    closeLoginModal() {
      this.pwdLoginModal = false
      this.errorMsg = ''
      if (this.timer) {
        clearInterval(this.timer)
      }
    },
    validateLogin(rules, form) {

    }
  }
}
</script>
<style lang="less" scoped>
@import '../index.less';
.pwdLogin {
  position: relative;
}
.loginIsRegister {
  padding-bottom: 34px;
  margin-bottom: 12px;
  border-bottom: 1px solid #d6dae3;
}
.ant-form-item {
  display: flex;
  width: 100%;
  margin-bottom: 19px;
  &.ant-form-item-with-help {
    margin-bottom: 0;
  }
  .input-box {
    display: flex;
    align-items: center;
  }

  /deep/ .ant-form-item-label {
    line-height: 48px;
  }
  // align-items: center;
  /deep/ .ant-form-item-control-wrapper {
    width: 100%;
    .ant-form-item-control {
      height: 100%;
      .ant-form-explain {
        font-size: 12px;
        line-height: 22px;
        padding: 0;
      }
    }
    .iconStyle {
      width: 16px;
      height: 16px;
      position: absolute;
      right: 10px;
      top: 0px;
    }
    input {
      box-sizing: border-box;
      width: 370px;
      height: 48px;
      background: #f5f8fa;
      border-radius: 6px;
      padding-right: 30px;
      font-size: 14px;
    }
  }
}
.login-toast-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 248px;
  background: rgba(0,0,0,0.6);
  box-shadow: 0px 5px 5px -3px rgba(0,0,0,0.1), 0px 8px 10px 1px rgba(0,0,0,0.06), 0px 3px 14px 2px rgba(0,0,0,0.05);
  border-radius: 4px;
  box-sizing: border-box;
  padding: 5px 8px;
  word-break: break-all;
  color: #fff;
}
</style>
